import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useProfileManagement from '@/domains/profile-management/hooks/useProfileManagement';
// import useAuth from '@/hooks/useAuth';
import NoticeMessage from '@/plugin/noticemessage/noticemessage';
import Button from '@/shared/components/ui/Button';
import DetailModal from '@/shared/components/ui/Modal/DetailModal/DetailModal';

// Import interface/type dari file terpisah
import type { UpdateProfileProps, UserInfo } from './UpdateProfile.types';

const UpdateProfile = ({ isActive = true, userInfo, commonData }: UpdateProfileProps) => {
  const { t } = useTranslation();
  const [isDisabled, setIsDisabled] = useState(true);
  const [formData, setFormData] = useState<UserInfo>({
    account_id: '',
    name: '',
    organization: '',
    email: '',
    position: '',
    phone_no: '',
  });

  const { updateUserProfile } = useProfileManagement({
    onUpdateSuccess: () => {
      setIsDisabled(true);
    },
    onResetFail: (err: unknown) => {
      const error = err as { message?: string };
      // TODO: Replace NoticeMessage with React-based toast/snackbar pattern
      new NoticeMessage(t(error?.message || ''));
    },
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setIsDisabled(false);
  };

  useEffect(() => {
    if (userInfo) {
      setFormData({
        account_id: userInfo.account_id,
        name: userInfo.name,
        organization: userInfo.organization,
        email: userInfo.email,
        position: userInfo.position,
        phone_no: userInfo.phone_no,
      });
    }
  }, [userInfo]);

  // Mobile account (numbers-only ID = health_care_facility_id): its ID moves
  // together with the facility link, so it is changed from User Management only.
  const isMobileAccount = /^[0-9]+$/.test(String(userInfo?.account_id ?? ''));

  const handleSubmit = async () => {
    updateUserProfile({ ...formData, account_id: formData.account_id?.trim() });
  };

  const tabClass = isActive
    ? 'flex flex-col pt-[20px] bg-transparent rounded-[4px] bg-[#135a78]'
    : 'pt-[20px]';

  return (
    <div className={tabClass}>
      <div className="w-full flex flex-col gap-[15px]">
        <span className="text-[20px] font-[700] text-[#6b7280] dark:text-text-white">
          {t('cmn > user profile')}
        </span>
      </div>
      <div className="grid grid-cols-2 gap-4 mt-4">
        <div className="flex flex-col gap-4">
          <DetailModal
            label={t('profile > id')}
            disabled={isMobileAccount}
            maxLength={20}
            inputType="text"
            name="account_id"
            modalType="profile"
            value={formData.account_id}
            onChange={handleChange}
          />
          <DetailModal
            label={t('user > name')}
            inputType="text"
            name="name"
            modalType="profile"
            value={formData.name}
            onChange={handleChange}
          />
          {/* <DetailModal
            label={t('user > organization')}
            inputType="select"
            name="organization"
            modalType="profile"
            value={formData.organization}
            onChange={handleChange}
            optionSelect={
              commonData?.ORG
                ? [
                    ...(commonData.ORG?.code?.map((code, index) => ({
                      value: code,
                      label: commonData.ORG?.name[index] ?? '',
                    })) || []),
                  ]
                : []
            }
          /> */}
        </div>

        <div className="flex flex-col gap-4">
          {/* <DetailModal
            label={t('021')}
            inputType="select"
            name="position"
            modalType="profile"
            value={formData.position}
            onChange={handleChange}
            optionSelect={
              commonData?.['021']
                ? [
                    ...(commonData['021']?.code?.map((code, index) => ({
                      value: code,
                      label: commonData['021']?.name[index] ?? '',
                    })) || []),
                  ]
                : []
            }
          /> */}
          <DetailModal
            label={t('user > phone no')}
            inputType="text"
            name="phone_no"
            modalType="profile"
            pattern={/^[0-9]*$/}
            value={formData.phone_no}
            onChange={handleChange}
          />

          <DetailModal
            label={t('profile > email')}
            inputType="text"
            name="email"
            modalType="profile"
            value={formData.email}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="flex justify-end mt-12">
        <Button
          label={t('cmn > save')}
          customButton="btn-search text-[14px]! h-[36px]!"
          disabled={isDisabled || !formData.account_id?.trim()}
          onClick={handleSubmit}
        />
      </div>
    </div>
  );
};

export default UpdateProfile;
